import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';

import Login from './components/Login/Login';
import App from './components/App/App';

const RestrictedRoute = ({ component: Component, ...rest, isLoggedIn }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn
        ? <Component {...props} />
        : <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />}
  />
);

const PublicRoutes = ({ history, isLoggedIn }) => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route
          path={'/login'}
          component={Login}
        />
        <RestrictedRoute
          path={'/'}
          component={App}
          isLoggedIn={isLoggedIn}
        />
      </Switch>
    </ConnectedRouter>
  );
};

export default connect(state => ({
  isLoggedIn: localStorage.getItem('auth') || false,
}))(PublicRoutes);



// WEBPACK FOOTER //
// ./src/router.js